import React from 'react';
import { MetricsCards } from './MetricsCards';
import { ChartingMfe } from './ChartingMfe';
import { AssetAllocation } from './AssetAllocation';
import { RecentTransactions } from './RecentTransactions';
import { InvestmentPortfolio } from './InvestmentPortfolio';
import { DebtPaydown } from './DebtPaydown';
import { MonthlyCashFlow } from './MonthlyCashFlow';
import { FinancialSchedules } from './FinancialSchedules';
import { SavingsGoals } from './SavingsGoals';
import { CategoryBudgetsMfe } from './CategoryBudgetsMfe';
import { SystemEvents } from './SystemEvents';
import { VaultMfe } from './VaultMfe';
import { ExpenseAnalyticsMfe } from './ExpenseAnalyticsMfe';
import type { DashboardProps } from './Dashboard.types';
import { useDashboard } from './Dashboard.hook';
import * as styles from './Dashboard.styles';

export const Dashboard: React.FC<DashboardProps> = (props) => {
  const { routesLoading, routes } = useDashboard(props);

  return (
    <div className={styles.dashboardGrid}>
      {/* Left Column */}
      <div className={styles.leftColumn}>
        <MetricsCards routesLoading={routesLoading} routes={routes} />
        <ChartingMfe routesLoading={routesLoading} routes={routes} />
        <ExpenseAnalyticsMfe />
        
        <div className={styles.innerGrid}>
          <AssetAllocation routesLoading={routesLoading} routes={routes} />
          <RecentTransactions routesLoading={routesLoading} routes={routes} />
        </div>
        
        <div className={styles.innerGrid}>
          <InvestmentPortfolio routesLoading={routesLoading} routes={routes} />
          <DebtPaydown routesLoading={routesLoading} routes={routes} />
        </div>
      </div>

      {/* Right Column */}
      <div className={styles.rightColumn}>
        <VaultMfe routesLoading={routesLoading} routes={routes} />
        <MonthlyCashFlow routesLoading={routesLoading} routes={routes} />
        <FinancialSchedules />
        <SavingsGoals routesLoading={routesLoading} routes={routes} />
        <CategoryBudgetsMfe routesLoading={routesLoading} routes={routes} />
        <SystemEvents />
      </div>
    </div>
  );
};

export default Dashboard;
